import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLanguageRequest } from "../../../../store/actions";
import { Ilanguages } from "./../../../../models/utilitiesModel";

const ThemeOneHome: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("translations");
  return (
    <>
      <div className="Kiosk_container">
        <div className="content-sec">
          <div className="welcometext ">
            <div>
              <h6>{t("Kiosk.welcome")}</h6>
              <h2>{t("Kiosk.welcomeFp")}</h2>
            </div>
            <div className="lg_cards">
              <button
                className="languagebtn"
                onClick={() => {
                  dispatch(setLanguageRequest(Ilanguages.ENG));
                }}
              >
                {t("Kiosk.eng")}
              </button>
              <button
                className="languagebtn"
                onClick={() => {
                  dispatch(setLanguageRequest(Ilanguages.ARB));
                }}
              >
                {t("Kiosk.arb")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(ThemeOneHome);
